/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ThumbUpOutlineIcon = function ThumbUpOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10341 9.99994C6.16488 9.81628 6.25305 9.64145 6.36606 9.48135L11.3599 2.40677C11.7021 1.92197 12.3888 1.84011 12.8354 2.23088L14.1607 3.39054C15.1943 4.29491 15.685 5.65911 15.4816 6.99994C15.4628 7.12395 15.438 7.24776 15.4072 7.37099L15 8.99994H18C20 8.99994 21.44 10.9199 20.88 12.8399L19.13 18.8399C18.7567 20.1199 17.5833 20.9999 16.25 20.9999H5C3.89543 20.9999 3 20.1045 3 18.9999V11.9999C3 10.8954 3.89543 9.99994 5 9.99994H6.10341ZM13.467 6.88592L12.4384 10.9999H18C18.6667 10.9999 19.1467 11.6399 18.96 12.2799L17.21 18.2799C17.0856 18.7066 16.6944 18.9999 16.25 18.9999H8L8 10.6347L12.3537 4.46697L12.8437 4.89569C13.4083 5.3897 13.6489 6.15812 13.467 6.88592Z"
  }));
};
export default ThumbUpOutlineIcon;